import { Link } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import SafeImage from '../../components/SafeImage';
import PostEngagementBar from '../social-post/PostEngagementBar';
import PostMediaGallery from '../social-post/PostMediaGallery';
import SocialQuoteReferenceCard from '../social-post/SocialQuoteReferenceCard';
import { travelMemberProductDisplayName } from '../member-identity/memberIdentityPresentation';
import { socialPostKindProductLabel } from '../social-post/socialPostKindPresentation';

function timeLabel(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
}

export default function CreatorPostCard({ post, onEngagementChange }) {
  const { t } = useTravelTranslation();
  const kindLabel = socialPostKindProductLabel(post.postKind);
  const detailPath = `/social/posts/${post.postId}`;
  const openLabel = `查看${kindLabel}貼文`;
  const authorName = post.author ? travelMemberProductDisplayName(post.author) : '';

  return (
    <article className="creator-post-card" data-testid={`creator-post-card-${post.postId}`}>
      <header className="creator-post-card__meta">
        {post.author ? (
          <Link className="creator-post-card__author" to={`/social/creators/${post.author.memberId}`}>
            {post.author.avatarUrl ? (
              <SafeImage className="creator-post-card__avatar" src={post.author.avatarUrl} alt="" />
            ) : (
              <span className="creator-post-card__avatar creator-post-card__avatar--fallback" aria-hidden="true">
                {authorName.slice(0, 1).toUpperCase()}
              </span>
            )}
            <span className="creator-post-card__author-copy">
              <strong>{authorName}</strong>
              <time dateTime={post.publishedAt || undefined}>{timeLabel(post.publishedAt)}</time>
            </span>
          </Link>
        ) : (
          <>
            <span className="creator-post-card__kind">{kindLabel}</span>
            <time dateTime={post.publishedAt || undefined}>{timeLabel(post.publishedAt)}</time>
          </>
        )}
        {post.author ? <span className="creator-post-card__kind">{kindLabel}</span> : null}
      </header>

      {post.location?.displayName ? (
        <p className="creator-post-card__location">{post.location.displayName}</p>
      ) : null}

      <Link className="creator-post-card__body" to={detailPath} aria-label={openLabel}>
        {post.text ? <p>{post.text}</p> : null}
      </Link>

      <PostMediaGallery media={post.media} href={detailPath} alt="" />

      {post.journey ? (
        <Link
          className="creator-post-card__journey creator-post-card__journey--compact"
          to={`/public/journeys/${post.journey.publicationId}`}
        >
          <span className="creator-post-card__journey-copy">
            <small>{t('travel.creator.publicItinerary')}</small>
            <strong>{post.journey.title}</strong>
            {post.journey.summary ? <em>{post.journey.summary}</em> : null}
          </span>
        </Link>
      ) : null}

      {post.quote ? (
        post.quote.available ? (
          <Link
            className="creator-post-card__quote"
            to={`/social/posts/${post.quote.postId}`}
            aria-label={post.quote.text || t('travel.creator.quotedFallback')}
          >
            <SocialQuoteReferenceCard quote={post.quote} />
          </Link>
        ) : (
          <div className="creator-post-card__quote creator-post-card__quote--unavailable">
            {t('travel.creator.quotedUnavailable')}
          </div>
        )
      ) : null}

      <PostEngagementBar
        postId={post.postId}
        engagement={post.engagement}
        detailTo={detailPath}
        shareTitle={post.text || 'Travel story'}
        onEngagementChange={onEngagementChange}
        className="creator-post-card__engagement"
      />
    </article>
  );
}
